import postsRaw from "./blogPosts.json";

// newest first
export function getAllPosts() {
  return [...postsRaw].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
}

export function getPost(slug) {
  return postsRaw.find((p) => p.slug === slug) || null;
}

// merge the language-specific fields (title/excerpt/tags/body) onto the post,
// falling back to Turkish then English.
export function localize(post, lang) {
  if (!post) return null;
  const l = post[lang] || post.tr || post.en || {};
  return { ...post, ...l };
}

export function getCategories() {
  return Array.from(new Set(postsRaw.map((p) => p.category)));
}

export function getRelated(slug, n = 3) {
  const post = getPost(slug);
  if (!post) return [];
  const others = getAllPosts().filter((p) => p.slug !== slug);
  const sameCat = others.filter((p) => p.category === post.category);
  const rest = others.filter((p) => p.category !== post.category);
  return [...sameCat, ...rest].slice(0, n);
}
